import React from 'react'
import { CButton, CModal, CModalBody } from '@coreui/react-pro'
import { QRCodeSVG } from 'qrcode.react'
import { submitAccept2FA } from './model'
import styles from './styles.module.css'
import { env } from '../../../../libs/constants'

type Props = {
  isVisible: boolean
  onClose: () => void
  qrCodeData: {
    qrCode: string
    id: string
  } | null
}

export const QRCodeModal: React.FC<Props> = ({
  isVisible,
  onClose,
  qrCodeData,
}) => {
  return (
    <CModal visible={isVisible} onClose={onClose}>
      <CModalBody>
        <div className={styles.qrCodeWrapper}>
          <QRCodeSVG value={qrCodeData?.qrCode || ''} size={300} />
        </div>
        <div className={styles.notificationText}>
          You need to scan the QR code using Google Authenticator to add a new
          account to it for subsequent receipt of authentication codes for
          entering the CRM. After successfully adding a new account to GA, be
          sure to confirm this action.
          <br />
          After confirming the successful addition of a new account to GA,
          re-receiving the QR code will only be possible with the help of the
          Administrator
        </div>
        {qrCodeData?.id && (
          <CButton
            onClick={() => {
              submitAccept2FA(qrCodeData.id)
              onClose()
            }}
            className={styles.buttonWrapper}
          >
            Added account
          </CButton>
        )}
      </CModalBody>
    </CModal>
  )
}
